<template>
      <main>
            <div class="grid xl:grid-cols-2">
                  <k-product-view v-for="(item, index) in home.featured" :key="index" :item="item" />
            </div>
            <section class="p-4">
                  <k-layout :content="page.layout" />
            </section>
      </main>
</template>

<script>
const KProductView = () =>
  import(/* webpackChunkName: "KProductView" */ "@/components/ProductView.vue");
const KLayout = () =>
  import(/* webpackChunkName: "KLayout" */ "@/components/Layout.vue");
import { mapState } from "vuex";
export default {
  name: "home",
  metaInfo() {
    return {
      title: this.site.title,
      titleTemplate: null,
    };
  },
  components: {
    KProductView,
    KLayout,
  },
  computed: {
    ...mapState(["site", "home"]),
      page() {
            return this.$store.state.pages[this.$route.name];
      },
  },
};
</script>
